import React, {useEffect, useState} from 'react'

import {Typography, Box} from "@material-ui/core"
import AccordionDetails from '@mui/material/AccordionDetails'

import Faq_Customization_Genre from './faqViews/customization/genre'
import Faq_Customization_Occasions from './faqViews/customization/occasions'
import Faq_Customization_Provide from './faqViews/customization/provide'
import Faq_Customization_Singer from './faqViews/customization/singer'

import Faq_Legal_Rights from './faqViews/legal/rights'
import Faq_Legal_Commercial from './faqViews/legal/commercial'

import Faq_Ordering_Payment from './faqViews/ordering/payment'
import Faq_Ordering_Refund from './faqViews/ordering/refund'
import Faq_Ordering_Rush from './faqViews/ordering/rush'
import Faq_Ordering_Session from './faqViews/ordering/session'

import Faq_Pricing_Base from './faqViews/pricing/base'
import Faq_Pricing_Costs from './faqViews/pricing/costs'
import Faq_Pricing_Extras from './faqViews/pricing/extras'

import Faq_Process_Process from './faqViews/process/process'
import Faq_Process_Lyrics from './faqViews/process/lyrics'
import Faq_Process_Miss from './faqViews/process/miss'
import Faq_Process_Reschedule from './faqViews/process/reschedule'
import Faq_Process_Revisions from './faqViews/process/revisions'
import Faq_Process_Style from './faqViews/process/style'
import Faq_Process_Time from './faqViews/process/time'
import Faq_Process_Unhappy from './faqViews/process/unhappy'

import Faq_Usage_Events from './faqViews/usage/events'
import Faq_Usage_Private from './faqViews/usage/private'
import Faq_Usage_Receipt from './faqViews/usage/receipt'
import Faq_Usage_Social from './faqViews/usage/social'

import Faq_AnalysisType from './faqViews/analysisType'
import Faq_AnnualFees from './faqViews/annualFees'
import Faq_BradnedCards from './faqViews/brandedCards'
import Faq_CreditScore from './faqViews/creditScore'
import Faq_RewardsType from './faqViews/rewardsType'
import Accordion from '../styled/Accordion'
import AccordionSummary from '../styled/AccordionSummary'
import {useStyles} from '../../themes/styles'

const headings = [
  {
    str: "About the Process",
    key: "process",
  },
  {
    str: "Pricing & Packages",
    key: "pricing",
  },
  {
    str: "Song Delivery & Usage",
    key: "usage",
  },
  {
    str: "Customization & Special Requests",
    key: "customization",
  },
  {
    str: "Technical & Legal",
    key: "legal",
  },
  {
    str: "Ordering & Payment",
    key: "ordering",
  },
  
]

const faqs = [
  {
    heading: "process",
    name: "process",
    question: "How does the custom song process work?",
    response: Faq_Process_Process,
  },
  {
    heading: "process",
    name: "lyrics",
    question: "How soon will I receive my lyrics after purchasing?",
    response: Faq_Process_Lyrics,
  },
  {
    heading: "process",
    name: "reschedule",
    question: "Can I reschedule my lyricist session?",
    response: Faq_Process_Reschedule,
  },
  {
    heading: "process",
    name: "miss",
    question: "What if I miss my lyricist session?",
    response: Faq_Process_Miss,
  },
  {
    heading: "process",
    name: "time",
    question: "How long does it take to receive my song?",
    response: Faq_Process_Time,
  },
  {
    heading: "process",
    name: "revisions",
    question: "Can I request revisions to the lyrics?",
    response: Faq_Process_Revisions,
  },
  {
    heading: "process",
    name: "unhappy",
    question: "What happens if I don’t like the final song?",
    response: Faq_Process_Unhappy,
  },
  {
    heading: "process",
    name: "style",
    question: "Can I choose the music style of my song?",
    response: Faq_Process_Style,
  },
  {
    heading: "pricing",
    name: "costs",
    question: "How much does a custom song cost?",
    response: Faq_Pricing_Costs,
  },
  {
    heading: "pricing",
    name: "base",
    question: "What’s included in the base package?",
    response: Faq_Pricing_Base,
  },
  {
    heading: "pricing",
    name: "extras",
    question: "What add-ons are available?",
    response: Faq_Pricing_Extras,
  },
  {
    heading: "usage",
    name: "receipt",
    question: "How will I receive my song?",
    response: Faq_Usage_Receipt,
  },
  {
    heading: "usage",
    name: "events",
    question: "Can I use my song for a wedding, proposal, or other events?",
    response: Faq_Usage_Events,
  },
  {
    heading: "usage",
    name: "private",
    question: "Will my song be private, or can I share it publicly?",
    response: Faq_Usage_Private,
  },
  {
    heading: "usage",
    name: "social",
    question: "Can I upload my song to social media?",
    response: Faq_Usage_Social,
  },
  {
    heading: "customization",
    name: "provide",
    question: "Can I provide my own lyrics or melody?",
    response: Faq_Customization_Provide,
  },
  {
    heading: "customization",
    name: "genre",
    question: "Can you make a song in a specific genre?",
    response: Faq_Customization_Genre,
  },
  {
    heading: "customization",
    name: "singer",
    question: "Can I request a specific singer?",
    response: Faq_Customization_Singer,
  },
  {
    heading: "customization",
    name: "occasions",
    question: "Do you create songs for occasions other than couples?",
    response: Faq_Customization_Occasions,
  },
  {
    heading: "legal",
    name: "rights",
    question: "Who owns the rights to the song?",
    response: Faq_Legal_Rights,
  },
  {
    heading: "legal",
    name: "commercial",
    question: "Can I use the song commercially?",
    response: Faq_Legal_Commercial,
  },
  {
    heading: "ordering",
    name: "payment",
    question: "What payment methods do you accept?",
    response: Faq_Ordering_Payment,
  },
  {
    heading: "ordering",
    name: "refund",
    question: "Can I get a refund if I change my mind?",
    response: Faq_Ordering_Refund,
  },
  {
    heading: "ordering",
    name: "rush",
    question: "Do you offer rush orders for faster delivery?",
    response: Faq_Ordering_Rush,
  },
  {
    heading: "ordering",
    name: "session",
    question: "How do I book my lyricist session?",
    response: Faq_Ordering_Session,
  },
]

const Faq = (props) => {
  const classes = useStyles()

  const [expanded, setExpanded] = useState(false)

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false)
  }

  useEffect(() => {
    window.scrollTo(0,0)
  },[])

  return ( <>
    <Typography variant="h4" sx={{}}>Frequently Asked Questions</Typography>
    <div className={classes.spacing}>
      {headings.map((stepHeading, indexHeading) => (
        <div className={classes.spacing}>
          <Typography variant="h5" sx={{}}>{stepHeading.str}</Typography>
          <div className={classes.spacing}>
            {faqs.map((step, index) => (
              step.heading == stepHeading.key ?
              // true ?
                <Accordion expanded={expanded === index} onChange={handleChange(index)}>
                  <AccordionSummary aria-controls={`panel-content_${step.name}`} id={`panel-header_${step.name}`}>
                    <Typography>{step.question}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box
                    component={step.response}
                    />
                  </AccordionDetails>
                </Accordion>
              : <></>
            ))}
          </div>
        </div>
        
      ))}
      {/* {faqs.map((step, index) => (
        <Accordion expanded={expanded === index} onChange={handleChange(index)}>
          <AccordionSummary aria-controls={`panel-content_${step.name}`} id={`panel-header_${step.name}`}>
            <Typography>{step.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box
            component={step.response}
            />
          </AccordionDetails>
        </Accordion>
      ))} */}
    </div>
  </> )
}

export default Faq
